import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import { useTheme } from "@mui/material/styles";

import { StyledBar, StyledCircle, StyledSteplabel, StyledStepperContainer, StyledStepperTitle } from "./styled";

const StepConnector = () => {
    return (
        <div>
            <StyledCircle />
        </div>
    );
};

type StepBarProps = {
    active: boolean;
};

const StepBar: FC<StepBarProps> = ({ active }) => {
    return (
        <div>
            <StyledBar $active={active} />
        </div>
    );
};

export type StepperData = {
    key: string;
    label: string;
};

type FlowStepsProps = {
    availableSteps: StepperData[];
    title: string;
    currentStep: string;
};

const FlowSteps: FC<FlowStepsProps> = ({ availableSteps, title, currentStep }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const steps = availableSteps;

    const orientation = isSmallScreen ? "horizontal" : "vertical";
    return (
        <StyledStepperContainer>
            <StyledStepperTitle>{title}</StyledStepperTitle>
            <Stepper
                classes={{ root: "stepper-root", horizontal: "stepper-horizontal", vertical: "stepper-vertical" }}
                className="stepper"
                orientation={orientation}
                alternativeLabel={orientation === "horizontal"}
                activeStep={steps
                    .map((e) => {
                        return e.key;
                    })
                    .indexOf(currentStep)}
                connector={<StepConnector />}
            >
                {steps.map((step) => (
                    <Step
                        key={`step-${step.key}`}
                        classes={{
                            horizontal: "step-horizontal",
                        }}
                    >
                        <StyledSteplabel
                            $active={currentStep === step.key}
                            StepIconComponent={StepBar}
                            classes={{ root: "steplabel-root", label: "steplabel-label" }}
                        >
                            {t(step.label)}
                        </StyledSteplabel>
                    </Step>
                ))}
            </Stepper>
        </StyledStepperContainer>
    );
};

export default FlowSteps;
